enum MonthlyTypeEnum {
    Default = 1,
    NonEscWorksData,
    EscWorksDashboardData
}

export default MonthlyTypeEnum;